import G2 from 'G2';
import moment from 'moment';
import Vue from 'vue';
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';
import statusMsg from '@/components/statusMsg.vue';

// let isLoadI18n = false; // 是否已经加载全局多语言
// let platformI18n = {}; // 全局多语言

function expandTree(tree) {
  const ret = [];
  tree.forEach((item) => {
    ret.push(item);
    if (item.children && item.children.length) {
      ret.push(...expandTree(item.children));
    }
  });
  return ret;
}

export default {
  provide() {
    return this.provide || this.isProvide
      ? {
        getI18n: () => this.i18n,
        getFunc: () => this.funcView,
      }
      : undefined;
  },
  computed: {
    i18n: (vm) => vm.baseI18n,
    funcView: (vm) => vm.baseFuncView,
    websiteEnv(vm) {
      if (vm.isDev) {
        return 3;
      } else if (vm.isMaster()) {
        return 1;
      } else {
        return 2;
      }
    },
    // 选择日期配置
    pickerOption() {
      return {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('Common.com_last_week'),
            onClick(picker) {
              // 0：0：0点到23：59：59
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_month'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_three_months'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      };
    },
    // 选择日期配置
    pickerOptionDisAfter() {
      return {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('Common.com_last_week'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_month'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_three_months'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        // disabledDate: time => time > new Date()
        // disabledDate: time => time.getTime() > this.$getLocalTime() + 8.64e7
        // 只能选择今天和以前的
        disabledDate: this.beforeToday,
      };
    },
    // 选择日期配置  现在时间是起点 往后推
    pickerOptionAfter() {
      return {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('Common.com_last_week'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_month'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_three_months'),
            onClick(picker) {
              const end = new Date(new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1));
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      };
    },
    pickerOptionDay() {
      return {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('Common.com_today'),
            onClick(picker) {
              picker.$emit('pick', new Date(new Date().setHours(0, 0, 0, 0)));
            },
          },
          {
            text: this.$t('Common.com_yesterday'),
            onClick(picker) {
              const date = new Date(new Date().setHours(0, 0, 0, 0));
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: this.$t('Common.com_a_week_ago'),
            onClick(picker) {
              const date = new Date(new Date().setHours(0, 0, 0, 0));
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      };
    },
  },
  data() {
    return {
      isPortal: false,
      // 【待删除】（base/dms已替换完成）
      pageSizeList: [8, 10, 16, 20, 30, 50, 100, 200],
      tableSelect: [],
      allTableSize: 'mini',
      isAllColumn: false,
      // 全局通用属性
      isDev: process.env.NODE_ENV === 'development',
      isUs: Cookies.get('siteCode') === 'us.prod',
      isInch: `${Cookies.get('nonMetric')}` === '1',
      appEnv: process.env.VUE_APP_ENV,
      baseI18n: {},
      baseFuncView: {},
      // ossConfig: {},
      propertyMap: {},
      dicMap: {},
      dicArrMap: {},
      isLoading: false,
      isProvide: false,
      // 表格相关属性
      tablePropMap: {},
      tableColumn: [],

      // 选择日期配置  现在时间是起点 往后推
      pickerOptionDayBefor: {
        firstDayOfWeek: 1,
        disabledDate: (time) => time > new Date(),
      },
      pickerOptionDayAfter: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(moment(time).format('YYYY-MM-DD')).diff(moment(new Date()).format('YYYY-MM-DD'), 'days') > 0,
      },

      pickerOptionsYear: {
        firstDayOfWeek: 1,
        disabledDate: (time) => time.getFullYear() > new Date().getFullYear(), // 注意是 || 不是 && 哦
      },
      pickerOptionsMonth: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      pickerOptionsWeek: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      dicCacheData: {},
      // 日期筛选 范围7天
      timeOptionRange: null,
      pickerOptionsIntervalWeek: {
        firstDayOfWeek: 1,
        onPick: (time) => {
          // 当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 6 * 1000;
          if (timeOptionRange) {
            return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
          }
          return moment(moment(time).format('YYYY-MM-DD')).diff(moment(new Date()).format('YYYY-MM-DD'), 'days') > 0;
        },
      },
      pickerOptionsIntervalThreeDays: {
        firstDayOfWeek: 1,
        // disabledDate: time => time > new Date(),
        onPick: (time) => {
          // 当第一时间选中才设置禁用
          if (time.minDate && !time.maxDate) {
            this.timeOptionRange = time.minDate;
          }
          if (time.maxDate) {
            this.timeOptionRange = null;
          }
        },
        disabledDate: (time) => {
          const timeOptionRange = this.timeOptionRange;
          const secondNum = 60 * 60 * 24 * 2 * 1000;
          if (timeOptionRange) {
            return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum;
          }
          return time > new Date();
        },
      },
      // 日期选择范围在一个月内
      pickerOptionsIntervalMonth: {
        firstDayOfWeek: 1,
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        // eslint-disable-next-line consistent-return
        disabledDate: (time) => {
          // 不能选择今天之后的日期
          const isAfterToday = moment(time).isAfter(this.$getLocalTime(), 'day');
          if (this.selectDate) {
            const limitRange = 31 * 24 * 3600 * 1000; // 31天范围内可选
            const maxTime = this.selectDate + limitRange;
            const minTime = this.selectDate - limitRange;
            return time.getTime() > maxTime || time.getTime() < minTime || isAfterToday;
          } else {
            return isAfterToday;
          }
        },
      },
      // 日期选择范围在一个月内（报表专用）不能选择2016年之前的
      pickerOptionsIntervalMonthReport: {
        firstDayOfWeek: 1,
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        // eslint-disable-next-line consistent-return
        disabledDate: (time) => {
          // 不能选择今天之后的日期
          const isAfterToday = moment(time).isAfter(this.$getLocalTime(), 'day');
          // 添加2016年1月1日的时间戳
          const minYearLimit = moment(this.$momentElLocal(moment('2016-01-01 00:00:00'))).valueOf();
          if (this.selectDate) {
            const limitRange = 31 * 24 * 3600 * 1000; // 31天范围内可选
            const maxTime = this.selectDate + limitRange;
            const minTime = this.selectDate - limitRange;
            // 添加不能选择2016年之前时间的限制
            return time.getTime() > maxTime || time.getTime() < minTime
                   || isAfterToday
                   || time.getTime() < minYearLimit;
          } else {
            // 添加不能选择2016年之前时间的限制
            return isAfterToday || time.getTime() < minYearLimit;
          }
        },
      },
      // 日期选择范围在三个月内
      pickerOptionsIntervalThreeMonth: {
        firstDayOfWeek: 1,
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        // eslint-disable-next-line consistent-return
        disabledDate: (time) => {
          // 不能选择今天之后的日期
          const isAfterToday = moment(time).isAfter(this.$getLocalTime(), 'day');
          if (this.selectDate) {
            const limitRange = 90 * 24 * 3600 * 1000; // 90天范围内可选
            const maxTime = this.selectDate + limitRange;
            const minTime = this.selectDate - limitRange;
            return time.getTime() > maxTime || time.getTime() < minTime || isAfterToday;
          } else {
            return isAfterToday;
          }
        },
      },
      IntervalThreeYearsStartDate: null,
      // 日期选择范围在三年内
      pickerOptionsIntervalThreeYears: {
        firstDayOfWeek: 1,
        onPick: (time) => {
          // 当选择了第一个日期时，记录起始日期
          if (time.minDate && !time.maxDate) {
            this.IntervalThreeYearsStartDate = time.minDate.getTime();
          }
          // 如果选择了第二个日期，则清空起始日期
          if (time.maxDate) {
            this.IntervalThreeYearsStartDate = null;
          }
        },
        disabledDate: (time) => {
          const currentTime = Date.now(); // 当前时间戳
          const timeStamp = time.getTime(); // 当前选中的日期时间戳
          // 添加2016年1月1日的时间戳
          const minYearLimit = moment(this.$momentElLocal(moment('2016-01-01 00:00:00'))).valueOf();
          if (this.IntervalThreeYearsStartDate) {
            // 计算允许的最大和最小日期（3年范围）
            const limitRange = 3 * 365 * 24 * 3600 * 1000; // 3年转化为毫秒
            const maxTime = this.IntervalThreeYearsStartDate + limitRange;
            const minTime = this.IntervalThreeYearsStartDate - limitRange;

            // 禁用超过 3 年范围、未来的日期或2016年之前的日期
            return (
              timeStamp > maxTime // 超过最大日期
        || timeStamp < minTime // 小于最小日期
        || timeStamp > currentTime // 禁止未来日期
        || timeStamp < minYearLimit // 禁止2016年之前的日期
            );
          } else {
            // 如果未选择第一个日期，则禁用未来的日期或2016年之前的日期
            return timeStamp > currentTime || timeStamp < minYearLimit;
          }
        },
      },

      // 昨天之前
      beforeYesterday: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).subtract(-1, 'd').isAfter(this.$getLocalTime(), 'day'),
      },
      // 今天之前
      beforeToday: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).isAfter(this.$getLocalTime(), 'day'),
      },
      // 今天之前2016之后的
      beforeToday2016: {
        disabledDate: (time) => {
          // 不能选择今天之后的日期
          const isAfterToday = moment(time).isAfter(this.$getLocalTime(), 'day');
          // 不能选择2016年之前的日期
          const isBefore2016 = moment(time).isBefore(this.$momentElLocal(moment('2016-01-01 00:00:00')), 'day');
          // 如果满足任一条件，则禁用该日期
          return isAfterToday || isBefore2016;
        },
      },
      // 今天之后
      afterToday: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).isBefore(this.$getLocalTime(), 'day'),
      },
      // 明天之后
      afterTomorrow: {
        firstDayOfWeek: 1,
        disabledDate: (time) => moment(time).subtract(1, 'd').isBefore(this.$getLocalTime(), 'day'),
      },
      // 时间分表查询限制
      // 当前时间在上半年 → 半年跨度，可以跨到上一年。
      // 当前时间在下半年 → 半年跨度，但只能在当年。
      // 往年 → 整年。
      // 未来 → 禁止。
      anchorDate: null,
      eventIntervalDays: {
        onPick: ({ minDate, maxDate }) => {
          if (minDate && !maxDate) {
            this.anchorDate = moment(minDate);
          }
          if (minDate && maxDate) {
            this.anchorDate = null;
          }
        },
        disabledDate: (time) => {
          const now = moment(this.$getLocalTime());
          const today = now.clone().endOf('day');
          const t = moment(time);

          if (t.isAfter(today)) {
            return true;
          }

          if (!this.anchorDate) {
            return false;
          }

          const anchor = this.anchorDate.clone();
          const anchorYear = anchor.year();
          const nowYear = now.year();
          const nowMonth = now.month() + 1;

          // 规则1 同年放行
          if (t.year() === anchorYear) {
            return false;
          }

          const allowCrossYear = (anchorYear === nowYear) || (anchorYear === nowYear - 1 && nowMonth <= 6);

          if (allowCrossYear) {
            // 缓冲天数，防止时区转换把选中日往后推一天
            const bufferDays = -1;

            const minSlide = anchor.clone().subtract(6, 'months').subtract(bufferDays, 'days').startOf('day');
            const maxSlide = anchor.clone().add(6, 'months').add(bufferDays, 'days').endOf('day');

            if (t.isBetween(minSlide, maxSlide, 'day', '[]')) {
              return false;
            }
          }

          return true;
        }
      }


    };
  },
  methods: {
    // RSA加密
    encrypt(text) {
      const encryptor = new JSEncrypt();
      const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKVitk3ktZR4+vabOMkW+8dxtAsFrB0q51O9NWvLhObq3sUMDGtHGfVdGtfuIzmkCQvWzc3n4x/kolZQW91bprECAwEAAQ==';
      encryptor.setPublicKey(publicKey);
      return encryptor.encrypt(text);
    },
    // 转换上午下午
    momentAmPm: function (dataStr) {
      if (!dataStr) {
        return dataStr;
      }
      return dataStr.replace('AM', this.$t('Common.com_am')).replace('PM', this.$t('Common.com_pm'));
    },
    // 是否是正式环境
    isMaster() {
      const host = window.location.host;
      const masterHosts = ['cn.ice980.com', 'us.ice980.com', 'eu.ice980.com', 'apac.ice980.com'];
      return masterHosts.includes(host);
    },
    // 获取paymentCode
    getPaymentCode(item) {
      if (item.billPayment) {
        return item.billPayment.paymentCode || item.paymentCode || item.billPaymentCode;
      }
      return item.paymentCode || item.billPaymentCode;
    },
    // this.getAttachUrl(item)  getAttachUrl(item)
    // 获取文件可访问地址
    getAttachUrl(item = {}) {
      const isFullImgUrl = /^http/;
      const { attachPath = '', attachUrl = '' } = item;
      return isFullImgUrl.test(attachPath) ? attachPath : attachUrl;
    },

    // 转换规则多语言
    initRules: function () {
      if (!this.rules || this.isTransformRules) {
        return;
      }
      this.isTransformRules = true;
      const rule = this.rules;
      Object.keys(rule).forEach((key) => {
        if (Array.isArray(rule[key])) {
          rule[key].forEach((ruleItem) => {
            if (ruleItem.lang) {
              ruleItem.message = `${this.$t(ruleItem.lang)}`;
            } else if (ruleItem.max && ruleItem.type !== 'number' && !ruleItem.min) {
              ruleItem.message = `${this.$t(`rules_str_length_max_${ruleItem.max}`)}`;
            }
            delete ruleItem.msg;
            delete ruleItem.lang;
          });
        } else {
          if (rule[key].lang) {
            rule[key].message = `${this.$t(rule[key].lang)}`;
          } else if (rule[key].max && rule[key].type !== 'number' && !rule[key].min) {
            rule[key].message = `${this.$t(`rules_str_length_max_${rule[key].max}`)}`;
          }
          delete rule[key].msg;
          delete rule[key].lang;
        }
      });
    },
    // 导出
    exportTable(apiKey, param) {
      return this.$exportFlie(apis[apiKey], param);
    },
    // 【待删除】表格选中变更
    selectionChange: function (selection, name = 'tableSelect') {
      this[name] = selection;
    },
    // 【待删除】表格全选事件
    setAllColumn: function (value) {
      this.tableColumn.forEach((item) => {
        item.selected = value;
      });
      this.formatTable();
    },
    // 【待删除】保存自定义列 tableCode
    saveTableColumn: function (value) {
      if (!value) {
        const columnIds = this.tableColumn.filter((t) => t.selected).map((t) => t.columnId);
        this.$postJSON(apis.TableColumSet, {
          columnIds: columnIds,
          tableCode: this.tableCode,
        }).then(() => {});
      }
    },
    // 【待删除】多语言转化(funcView, i18n)
    // lang: function (value, code, key = 'funcView') {
    //   return Object.keys(this[key]).length === 0 ? ' ' : this[key][code] || `【默认】${value}`;
    // },
    // 【待删除】格式化表格列 formatColumn
    formatColumn: function (row, col) {
      const column = this.tableColumn[col.index];
      let result = '';
      // 格式化字典
      if (column.formatRule === 'dic_group' && column.dicGroup) {
        const group = this.$transformDicValue(this.tablePropMap[column.dicGroup]);
        const value = `${row[col.property]}`;
        result = group[value] || '';
      }
      // 格式化日期
      if (column.formatRule === 'tableField_date' && column.dicGroup) {
        const group = this.$transformDicCode(this.tablePropMap.bas_tableField_dateFormat);
        const param = group[column.dicGroup];
        if (param && row[col.property]) {
          result = moment(row[col.property]).format(param);
        }
      }
      return result;
    },
    // 【待定】弹窗组件（王彬弹窗设计标准）
    statusMsg(config = {}) {
      const opts = Object.assign(
        {
          title: this.$t('Common.com_reminder'),
          // 第一行文本
          subTitle: '',
          // 第二行文本
          message: '',
          cancelBtnText: this.$t('Common.com_cancel'),
          confirmBtnText: this.$t('Common.com_confirm'),
          // pass error warning
          type: 'pass',
          // autoHidden为true时，提示框消失的时间间隔
          delay: 1500,
          // 提示框显示后是否自动关闭
          autoHidden: false,
        },
        config
      );
      return new Promise((resolve, reject) => {
        const Comp = Vue.extend(statusMsg);
        const inst = new Comp({
          data: opts,
        });
        const pNode = document.createElement('div');
        inst.$on('close', (type) => {
          if (type === 'confirm') {
            resolve(true);
          } else {
            reject();
          }
          // 删除实例，移除dom
          setTimeout(() => {
            inst.$destroy();
            pNode.parentNode.removeChild(pNode);
          }, 300);
        });

        inst.$mount();
        pNode.appendChild(inst.$el);
        document.body.appendChild(pNode);

        // 浏览器渲染需要时间,否则动画流畅性不好
        setTimeout(() => {
          inst.show();
        }, 100);
      });
    },
    // 字典值转指点名称
    getDicValue(dicName, dicValue, nameKey = 'name') {
      if (!dicName || (!dicValue && dicValue !== 0)) {
        return '';
      }
      if (!this.dicCacheData[dicName]) {
        Vue.set(this.dicCacheData, dicName, {});
        this.getDictionary(dicName, (dic) => {
          const data = dic[dicName];
          const map = {};
          data.forEach((item) => {
            map[`${item.value}`] = item;
          });
          this.dicCacheData[dicName] = map;
        });
      }
      const ret = this.dicCacheData[dicName][`${dicValue}`];
      return ret === undefined ? '' : ret[nameKey];
    },
    // 批量获取附件  key 返回值修改的key默认是'attachPath' returnType返回的类型 默认是'String'
    formatAttachList: async function (list, bizKey, bizType, key = 'attachPath', returnType = 'String') {
      if (!list || list.length === 0) {
        return list;
      }
      const bizIdList = [...new Set(list.map((t) => t[bizKey]))].filter((t) => !!t);
      if (bizIdList.length === 0) {
        return list;
      }
      const bizIds = [...new Set(list.map((t) => t[bizKey]))].filter((t) => !!t).join(',');
      const res = await this.$getJSON(apis.OssBatchAttach, { bizIds, bizType });
      list.forEach((item) => {
        const row = res.data.find((t) => t.bizId === item[bizKey]) || {};
        if (row && returnType === 'Array') {
          if (Array.isArray(item[key]) && this.getAttachUrl(row) !== '') {
            item[key].push(this.getAttachUrl(row));
          }
          if (this.getAttachUrl(row) !== '') {
            item[key] = [this.getAttachUrl(row)];
          }
        } else {
          item[key] = this.getAttachUrl(row);
        }
      });
      return list;
    },
    // 验证规则多语言
    initRule: function () {
      if (!this.rules || this.isTransformRules) {
        return;
      }
      this.isTransformRules = true;
      const rule = this.rules;
      Object.keys(rule).forEach((key) => {
        if (Array.isArray(rule[key])) {
          rule[key].forEach((ruleItem) => {
            if (ruleItem.lang) {
              ruleItem.message = `${this.i18n[ruleItem.lang]}`;
            } else if (ruleItem.max && ruleItem.type !== 'number' && !ruleItem.min) {
              ruleItem.message = `${this.i18n[`rules_str_length_max_${ruleItem.max}`]}`;
            }
            delete ruleItem.msg;
            delete ruleItem.lang;
          });
        } else {
          if (rule[key].lang) {
            rule[key].message = `${this.i18n[rule[key].lang]}`;
          } else if (rule[key].max && rule[key].type !== 'number' && !rule[key].min) {
            rule[key].message = `${this.i18n[`rules_str_length_max_${rule[key].max}`]}`;
          }
          delete rule[key].msg;
          delete rule[key].lang;
        }
      });
    },
    // // 获取oss配置
    // getOssConfig: function () {
    //   this.$getJSON(apis.ossUpload).then((res) => {
    //     this.ossConfig = res.data;
    //   });
    // },
    // 格式化表格布局 ref='tb1'
    formatTable: function () {
      this.isAllColumn = !this.tableColumn.find((t) => !t.selected);
      this.$nextTick(() => {
        if (this.$refs.tb1 && this.$refs.tb1.doLayout) {
          this.$refs.tb1.doLayout();
        }
      });
    },
    // 获取下拉字典 propertyMap
    getDictionary: function (codes, cb, key = 'propertyMap') {
      cb = cb || function () {};
      const dicGroup = this.$store.state.dictionary;
      const diffCodes = codes.split(',').filter((t) => !Object.keys(dicGroup).includes(t));
      if (diffCodes.length === 0) {
        this.$setFormatData(this[key], dicGroup, codes);
        cb(this[key]);
        return;
      }
      this.$getJSON(apis.DictionaryCode, {
        groupCodes: diffCodes.join(','),
      }).then((res) => {
        const groups = {};
        this.$setFormatData(groups, Object.assign(dicGroup, res.data), codes);
        this[key] = groups;
        cb(this[key]);
        this.$store.commit('DICTIONARY', Object.assign(dicGroup, res.data));
      });
    },
    // 将字典转为 {code1,: value1}，数据存储在dicMap中
    getDicMap(codes, cb, props = { propKey: 'code', propVal: 'value' }) {
      this.getDictionary(codes, (data) => {
        const codeArr = codes.split(',');

        Object.keys(data).forEach((key) => {
          if (codeArr.includes(key)) {
            const dicList = data[key];
            const map = {};
            dicList.forEach((obj) => {
              map[obj[props.propKey]] = obj[props.propVal];
            });
            this.$set(this.dicMap, key, map);
          }
        });
        if (cb) {
          cb(this.dicMap);
        }
      });
    },
    // 将字典转为 [{label,value}],数据存储在dicArrMap中
    getDicArrMap(codes, cb) {
      this.getDictionary(codes, (data) => {
        Object.keys(data).forEach((key) => {
          const dicList = data[key];
          dicList.forEach((obj) => {
            obj.label = obj.name;
          });
          this.$set(this.dicArrMap, key, dicList);
        });
        if (cb) {
          cb(this.dicArrMap);
        }
      });
    },
    // 获取字典项
    getDictionaryItem: function (codeName) {
      this.getDictionary(codeName, () => this.propertyMap[codeName]);
      return this.propertyMap[codeName];
    },
    // 获取菜单下功能按钮 baseFuncView
    getFuncView: function (loadRes, cb) {
      loadRes = loadRes || this.$route.path;
      cb = cb || function () {};
      const cache = this.$store.state.funcView;
      if (cache[loadRes]) {
        this.baseFuncView = cache[loadRes];
        cb(cache[loadRes]);
        return;
      }
      this.$getJSON(apis.FuncView, { loadRes: loadRes }).then((res) => {
        this.baseFuncView = res.data;
        this.$store.commit('FUNCVIEW', Object.assign(cache, { [loadRes]: res.data }));
        cb(res.data);
      });
    },
    // 获取多语言配置 baseI18n
    // getLanguage: function (cb, loadRes) {
    //   // this.asyncLanguage(loadRes, () => {
    //   this.isProvide = true;
    //   loadRes = loadRes || this.$route.path;
    //   cb = cb || function () {};
    //   const cache = this.$store.state.language;
    //   if (!this.isDev && cache[loadRes]) {
    //     this.baseI18n = cache[loadRes];
    //     this.initRule();
    //     cb();
    //     return;
    //   }
    //   this.getAllLanguage(() => {
    //     this.$getJSON(apis.LanguageView, { loadRes: loadRes }).then((res) => {
    //       const result = res.data || {};
    //       const defaultI81n = this.translate ? this.translate.i18n : {};
    //       this.baseI18n = Object.assign({}, defaultI81n, platformI18n, result);
    //       this.$store.commit('LANGUAGE', Object.assign(cache, { [loadRes]: this.baseI18n }));
    //       this.initRule();
    //       cb();
    //     });
    //   });
    //   // });
    // },
    // 获取公共组件多语言 i18n
    // getCompLanguage: function (cb, code) {
    //   // this.asyncCompLanguage(code, () => {
    //   cb = cb || function () {};
    //   const cache = this.$store.state.language;
    //   if (!this.isDev && !!code && cache[code]) {
    //     this.baseI18n = cache[code];
    //     this.initRule();
    //     cb();
    //     return;
    //   }
    //   this.getAllLanguage(() => {
    //     if (!code) {
    //       this.baseI18n = Object.assign({}, platformI18n);
    //       return;
    //     }
    //     this.$getJSON(apis.LanguagePlatform, {
    //       keyGroupCode: code,
    //     }).then((res) => {
    //       const result = res.data || {};
    //       const defaultI81n = this.translate ? this.translate.i18n : {};
    //       this.baseI18n = Object.assign({}, platformI18n, defaultI81n, result);
    //       this.$store.commit('LANGUAGE', Object.assign(cache, { [code]: this.baseI18n }));
    //       this.initRule();
    //       cb();
    //     });
    //   });
    //   // });
    // },
    // 获取全局多语言
    // getAllLanguage: function (cb) {
    //   cb = cb || function () {};
    //   if (isLoadI18n) {
    //     cb();
    //     return;
    //   }
    //   this.$getJSON(apis.LanguagePlatform).then((res) => {
    //     isLoadI18n = true;
    //     platformI18n = res.data || {};
    //     const langCode = Cookies.get('langCode') || 'CN';
    //     this.$i18n.mergeLocaleMessage(langCode, res.data || {});
    //     cb();
    //   });
    // },
    // 获取表格列 tableCode、tableColumn、isAllColumn
    getTableColumn: function (filterArr) {
      this.$getJSON(apis.TableColumnGet, { tableCode: this.tableCode }).then((res) => {
        let tableColumn = res.data || [];
        if (filterArr) {
          filterArr.forEach((filterCode) => {
            tableColumn = tableColumn.filter((i) => i.columnCode !== filterCode);
          });
        }
        // 获取字典
        const codes = tableColumn.filter((t) => t.isFormat && t.formatRule === 'dic_group').map((f) => f.dicGroup);
        const hasDate = tableColumn.find((t) => t.formatRule === 'tableField_date');
        if (hasDate) {
          codes.push('bas_tableField_dateFormat');
        }
        if (codes.length) {
          this.getDictionary(
            codes.join(','),
            () => {
              tableColumn.forEach((item) => {
                if (item.isFormat && item.formatRule === 'dic_group' && item.checkbox) {
                  const tablePropMaps = this.tablePropMap[item.dicGroup].map((t) => ({
                    text: t.name,
                    value: t.value,
                    code: t.code,
                  }));
                  const rules = item.checkboxRule && item.checkboxRule.split(',');
                  item.filters = item.checkboxRule ? tablePropMaps.filter((t) => rules.includes(t.code)) : tablePropMaps;
                }
              });
              this.tableColumn = tableColumn;
              this.formatTable();
            },
            'tablePropMap'
          );
        } else {
          this.tableColumn = tableColumn;
          this.formatTable();
        }
      });
    },
    // 表格禁用行
    onSelectable: function (row) {
      return !row.isExists;
    },
    // 表格列排序
    sortChange: function ({ prop, order }) {
      this.formSearch.orderBy = prop;
      if (order) {
        this.formSearch.orderType = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this.formSearch.orderType = '';
        this.formSearch.orderBy = '';
      }
      this.onPageChange({ page: 1 });
    },
    // 表格列过滤
    filterChange: function (value) {
      this.formSearch = Object.assign(this.formSearch, value);
      this.onPageChange({ page: 1 });
    },
    // 表格列设置
    setColumn: function (table) {
      const column = this.$refs[table.columnRef || 'column'];
      if (column) {
        column.tableCode = table.tableCode;
        column.tableColumn = table.tableColumn;
        column.formatTable();
      }
    },
    // 清除缓存
    clearKeepAlive: function (componentName) {
      const includeList = this.$store.state.vm.includeList;
      const includes = includeList.filter((t) => t !== componentName);
      this.$store.commit('INCLUDELIST', includes);
    },
    // 移除标签
    clearTagByKeep: function (keep) {
      const tagList = this.$store.state.vm.tags;
      const tags = tagList.filter((t) => t.keep !== keep);
      this.$store.commit('TAGS', tags);
    },
    // 判断是否为内嵌页
    async isEmbeddedPage(path) {
      const menuRecord = this.$store.state.menuRecord;
      const appId = this.$store.state.appId;
      let navList;
      if (menuRecord[appId]) {
        navList = menuRecord[appId];
      } else {
        navList = await this.$getJSON(apis.MenuTree, {
          appId: this.$store.state.appId,
        }).then((res) => res.data);
        menuRecord[appId] = navList;
        this.$store.commit('MENU_RECORD', menuRecord);
      }

      const allList = expandTree(navList);
      return allList.some((item) => item.loadRes === path);
    },
    // 路由跳转
    jump: async function (to, query, isReplace, isInitMenu = false) {
      if (typeof to === 'number') {
        this.$router.go(to);
        return;
      }
      const method = isReplace ? 'replace' : 'push';
      const params = query || {};
      // if (!params.parentPath) {
      //   const isEmbeddedPage = await this.isEmbeddedPage(to);
      //   if (isEmbeddedPage) {
      //     params.parentPath = this.$route.path;
      //   }
      // }
      this.$router[method]({ path: to, query: params }, () => {});
      if (isInitMenu) {
        this.Bus.$emit('initMenu', to);
      }
    },
    // 获取路由信息
    getJump: function (name, value) {
      value = typeof value === 'undefined' ? '' : value;
      return this.$route.query[name] || value;
    },
    // 跳转外链 (联系客服则传入`tel:${tel}`)
    jumpOutside: function (path, _blank) {
      if (!path) {
        return;
      }
      if (_blank) {
        window.open(path);
        return;
      }
      window.location.href = path;
    },
    // 跳转新Tab
    jumpNewTab: function (path) {
      if (!path) {
        return;
      }
      window.open(path);
    },
    // 格式化日期（后面移除）
    formatDate: function (row, column) {
      return this.$momentLocal(row[column.property], 'YYYY-MM-DD');
    },
    // 格式化日期(时间是字符串)
    str2FormatDate: function (row, column) {
      return this.$momentLocal(+row[column.property], 'YYYY-MM-DD');
    },
    // 格式化日期字符串（YYYY-MM-DD HH:mm:ss）
    formatDateTime: function (date) {
      return this.$momentLocal(date, 'YYYY-MM-DD HH:mm:ss');
    },
    // 格式化日期Date类型（YYYY-MM-DD HH:mm:ss）
    formatDateTimeDate: function (date) {
      return this.$momentLocal(date, 'YYYY-MM-DD HH:mm:ss');
    },
    // 格式化时分加冒号（HH:mm）
    formatHhmmStr: function (time) {
      const reg = /^(\d{1,2})(\d{2})$/;
      const isPass = reg.test(time);
      const s1 = isPass && time.replace(reg, '$1:$2');
      if (isPass) {
        return s1;
      } else {
        return time;
      }
    },
    // 格式化时间去冒号（HH:mm）
    formatHhmmColonStr: function (time) {
      const reg = /^(\d{1,2}):(\d{2})$/;
      const isPass = reg.test(time);
      const s1 = isPass && time.replace(reg, '$1$2');
      if (isPass) {
        return s1;
      } else {
        return '0000';
      }
    },
    // 生成当前时间YYYYMM字符串
    formatSrtYYYYMM: function (str) {
      const timeStr = moment().format('YYYYMM');
      const strReplace = str.replace(/YYYYMM/g, timeStr);
      return strReplace;
    },
    // 生成当前时间YYYYMMDD字符串
    formatSrtYYYYMMDD: function (str) {
      const timeStr = moment().format('YYYYMMDD');
      const strReplace = str.replace(/YYYYMMDD/g, timeStr);
      return strReplace;
    },
    // 微信扫码登录
    wxScanLogin: function (appId, state = 'login') {
      const AuthUrl = 'https://open.weixin.qq.com/connect/qrconnect?';
      const redirectUri = encodeURI(`${window.location.origin}/wechatlogin`);
      const baseUrl = `${AuthUrl}appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_login`;
      const wxLoginUrl = `${baseUrl}&state=${state}#wechat_redirect`;
      window.location.href = wxLoginUrl;
    },
    // 环形饼图, 销毁：destroy()
    initG2Ring(ref, data, param) {
      const params = Object.assign(
        {
          title: '我的设备',
          item: 'item', // 类别key
          value: 'count', // 值key
          height: 200, // 高度
          showTotal: true, // 显示合计
          totalSize: 28,
        },
        param
      );
      const chart = new G2.Chart({
        padding: { bottom: 0, top: 0, right: 100 },
        container: this.$refs[ref],
        height: params.height,
        forceFit: false,
        animate: false,
      });
      // 合计
      const total = data.reduce((pre, item) => pre + (item[params.value] || 0), 0);
      // 数据注入
      const config = {};
      config[params.item] = {
        alias: params.title, // 设置属性的别名
      };
      chart.source(data, config);
      // 设置坐标系类型
      chart.coord('theta', {
        radius: 55, // 半径
        innerRadius: 0.72, // 空心圆半径
      });
      // 鼠标提示
      chart.tooltip({
        showTitle: false,
        itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
      });
      // 合计
      if (params.showTotal) {
        chart.guide().html({
          position: ['50%', '50%'],
          html: params.subTitle
            ? `<div style="transform: translate(-50%, -50%); color:rgba(0,0,0,0.85);font-size: 12px;text-align: center; font-weight: bold; line-height: 20px">
        ${params.subTitle}<br><span style="color:rgba(0,0,0,0.85);font-size:${params.totalSize}px">${total}</span></div>`
            : `<div style="color:rgba(0,0,0,0.85);font-size: 12px;text-align: center; font-weight: bold;font-size:${params.totalSize}px">${total}</div>`,
          alignX: 'middle',
          alignY: 'middle',
        });
      }
      // 图例
      chart.legend({
        position: 'right-center',
        layout: 'horizontal',
        itemGap: 40, // 图例项之间的间距
        itemWidth: 40,
        title: {
          fill: 'rgba(0,0,0,0.85)', // 文本的颜色
          fontSize: '12', // 文本大小
          fontWeight: 'bold', // 文本粗细
        },
        offsetY: 20,
        offsetX: -110,
      });
      chart.intervalStack().position(params.value).color(params.item).style({
        lineWidth: 1,
        stroke: '#fff',
      });
      chart.render();
    },

    /**
     * 模糊查询
     * @param {array<object>} list
     * @param {array<string>} keys
     * @param {string} keywork
     * @return {array<object>} result
     */
    fuzzyQuery(list, keys, keywork) {
      return list.filter((item) => {
        const vals = keys.map((key) => item[key]);
        return vals.some((val) => val.includes(keywork));
      });
    },
    /**
     * 空值转默认值—
     * @param {array<object>} list
     * @param {array<string>} exclude
     * @return {array<object>} ret
     */
    nullValueToCrossbar(list, exclude = []) {
      list.forEach((obj) => {
        Object.keys(obj).forEach((key) => {
          if (!exclude.includes(key) && (!obj[key] || obj[key] === 'null' || obj[key] === '00:00' || obj[key] === 0)) {
            obj[key] = '-';
          }
        });
      });
      return list;
    },
    /**
     * 获取fms模块可用balance值
     * @param {object} data 账单详情接口返回的数据
     * @return {number} ret
     */
    getBalance(data) {
      const billPayment = data.billPayment || {
        totalPaymentAmount: 0,
        totalTradeAmount: 0,
        tradeState: 1,
      };
      const partnerBalance = data.partnerBalance || {
        balanceAmount: 0,
        lockAmount: 0,
      };
      const totalPaymentAmount = billPayment.totalPaymentAmount || 0;
      const totalTradeAmount = billPayment.totalTradeAmount || 0;
      const tradeState = billPayment.tradeState || 1;
      const balanceAmount = partnerBalance.balanceAmount || 0;
      const lockAmount = partnerBalance.lockAmount || 0;
      if (tradeState === 1) {
        return balanceAmount - lockAmount;
      }
      return totalPaymentAmount - totalTradeAmount >= 0 ? balanceAmount - lockAmount + totalPaymentAmount - totalTradeAmount : balanceAmount - lockAmount;
    },
    // 获取交易时所拥有的余额（后端未结算余额到总余额时的那个余额）
    // 最终结余总额 - 交易时产生的结余
    getTradeBalance(data) {
      // const billPayment = data.billPayment || {
      //   totalPaymentAmount: 0,
      //   totalTradeAmount: 0,
      //   tradeState: 1,
      //   tradeBalanceAmount: 0,
      // };
      // const partnerBalance = data.partnerBalance || {
      //   balanceAmount: 0,
      //   lockAmount: 0,
      // };
      // // 交易时产生的结余
      // const tradeBalanceAmount = billPayment.tradeBalanceAmount || 0;
      // const tradeState = billPayment.tradeState || 1;
      // const balanceAmount = partnerBalance.balanceAmount || 0;
      // const lockAmount = partnerBalance.lockAmount || 0;
      // if (tradeState > 6) {
      //   const balanceTotal = balanceAmount - lockAmount;

      //   if (balanceTotal === 0) {
      //     return this.getBalance(data);
      //   }
      //   return Math.max(0, balanceTotal - tradeBalanceAmount);
      // }
      // return this.getBalance(data);

      // 需求反水，用回原来的getBalance
      return this.getBalance(data);
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    getFilePreviewUrl(file) {
      if (URL && URL.createObjectURL) {
        const url = URL.createObjectURL(file);
        return Promise.resolve(url);
      } else {
        return new Promise((resolve) => {
          const fileReader = new FileReader();

          fileReader.readAsDataURL(file);
          // 异步加载
          fileReader.onload = function (event) {
            resolve(event.target.result);
          };
        });
      }
    },

    /**
     * 合并两个数组，去除重复项
     * @param {Array} targetArr
     * @param {Array} sourceArr
     * @param {String} id 判断是否为重复项的标识
     * @return {Array} ret
     */
    mergeArr(targetArr, sourceArr, id) {
      const ret = [...targetArr];
      sourceArr.forEach((item) => {
        if (!targetArr.some((tItem) => `${tItem[id]}` === `${item[id]}`)) {
          ret.push(item);
        }
      });
      return ret;
    },
    /**
     * 判断是否为收款方
     * @param {String} receivableOrgId
     * @return {Boolean} isReceivableOrg
     */
    isReceivableOrg(receivableOrgId) {
      const userInfo = this.$store.state.userInfo;
      if (userInfo) {
        return userInfo.rootOrgId === receivableOrgId;
      }
      return false;
    },
    /**
     * 判断是否为付款方
     * @param {String} payableOrgId
     * @return {Boolean} isPayableOrg
     */
    isPayableOrg(payableOrgId) {
      const userInfo = this.$store.state.userInfo;
      if (userInfo) {
        return userInfo.rootOrgId === payableOrgId;
      }
      return false;
    },

    /**
     * @typedef {Object} LocationNameAndSiteNameInfo 具有locationName和siteName属性的对象
     * @property {String} locationName 项目名称
     * @property {String} siteName 区域
     */

    /**
     * 获取： 项目/区域
     * @param {LocationNameAndSiteNameInfo} row
     * @return {String} 项目/区域
     */
    getLocationNameAndSiteName(row) {
      const { locationName, siteName } = row;
      const arr = [];
      if (locationName) {
        arr.push(locationName);
      }
      if (siteName) {
        arr.push(siteName);
      }
      return arr.join('/');
    },
    /**
     * 表格列筛选默认值设置
     * @param {String} tableRefs 表格引用名
     * @param {String} tabIndex custom-tab的值
     * @param {String} curTable 组件名字
     */
    setDefaultFilterValue(tableRefs = 'customTb1', tabIndex = 'tabIndex', curTable = 'status') {
      let callback = () => {};
      // 遍历 param 对象的每个键
      for (const key in this.param) {
        if (this.param.hasOwnProperty(key)) {
          const value = this.param[key];
          // 如果 key 是 tabIndex 或 curTable，赋值给 this 对象的属性
          if (key === 'tabIndex' && value) {
            this[tabIndex] = value;
          } else if (key === 'curTable' && value) {
            this[curTable] = value;
          } else if (key === 'formSearch' && value && this.formSearch) {
            // 携带搜索
            setTimeout(() => {
              this.$setFormatData(this.formSearch, JSON.parse(this.param.formSearch));
              // this.getTableList();
            }, 500);
            callback = () => {
              this.getTableList();
            };
          } else {
            //   console.log(this.$refs[tableRefs], key, value);
            if (!this.$refs[tableRefs]) {
              return;
            }
            let refs = null;
            setTimeout(() => {
              // table 会有延迟，需要等待一下
              refs = this.$refs[tableRefs].$refs.tb1;
              // 查找 tableColumn 中是否存在 columnCode 与 key 匹配的对象
              const index = refs.columns.findIndex((col) => col.columnKey === key && col.filters && col.filters.length > 0);
              if (index !== -1) {
                // 找到了，将过滤值设置为 param 对应的值
                const column = refs.columns[index];
                const param = this.$parseQueryParam(this.param[key]);// 这里数组包裹，否则一个的时候变成字符串
                refs.columns[index].filteredValue = param;
                refs.store.commit('filterChange', {
                  column,
                  values: param,
                });

                // refs.store.updateAllSelected();
              }
            }, 500);
            callback = () => {
              refs.store.updateAllSelected();
            };
          }
        }
      }
      setTimeout(() => {
        callback();
      }, 1000);
    },
  },
};
